import { useEffect } from 'react';

const SmoothScroll = () => {
  useEffect(() => {
    const handleAnchorClick = (event) => {
      // Asegurarnos de que solo estamos afectando los enlaces con href="#"
      if (event.target.tagName === 'A' && event.target.getAttribute('href').startsWith('#')) {
        event.preventDefault(); // Prevenimos el comportamiento por defecto de los enlaces
        const targetId = event.target.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth', // Hacemos el desplazamiento suave
            block: 'start', // Aseguramos que el desplazamiento sea desde la parte superior del contenedor
          });
        }
      }
    };

    // Añadimos el evento de click para todos los enlaces
    document.addEventListener('click', handleAnchorClick);

    // Limpiar el evento al desmontar el componente
    return () => {
      document.removeEventListener('click', handleAnchorClick);
    };
  }, []);

  return null;
};

export default SmoothScroll;
